import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./ClinicalTrail.css";

const ClinicalTrail = () => {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const tokenData = JSON.parse(localStorage.getItem("tokendata"));
  console.log(tokenData?.token, "dfsdfdfgfdg4343543ff");

  const handleClose = () => {
    navigate('/myresearch'); // Go back to previous page
  };

  return (
    <div className="clinicaltrail-wrapper">
      {/* Header with Close Button */}
      <div className="clinicaltrail-header">
        <div className="clinicaltrail-header-content">
          <div className="navbar-logo">
            <img src="/helth.png" alt="HealthLabs AI" className="navbar-logo-img" />
          </div>
          {/* <h2 className="clinicaltrail-title" /> */}
          <button
            className="clinicaltrail-close-btn"
            onClick={handleClose}
            aria-label="Close"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>
      </div>

      {/* Iframe Container */}
      <div className="clinicaltrail-iframe-container">
        {loading && (
          <div className="clinicaltrail-loader">
            <div className="spinner"></div>
            <p>Loading...</p>
          </div>
        )}

        <iframe
          src={`https://s2.genetica.ai:3001/apps/cortex/#/dashboard/graphs/list?token=${tokenData?.token}`}
          className="clinicaltrail-iframe"
          frameBorder="0"
          allowFullScreen
          onLoad={() => setLoading(false)}
        />
      </div>
    </div>
  );
};

export default ClinicalTrail;
